<style scoped>
    @import url("../../../styles/smartControl/formAgend.scss");
</style>

<template>
    <div class="box_formAgend">

        <div class="mainTit mb-2">
            <span>{{ titForm }}</span>
        </div>

        <div v-if="handleLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="menuForm" v-if="!handleLoading">

            <div class="linhaForm">
                <span class="tLinha">Data:</span><span class="ml-2">{{ dateToday }}</span>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Horário:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hr_utc"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        :placeholder="formLocal.hr_utc"
                        @change="atualizarFormulario('hhmm')"
                    />
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':'wrap'}">
                <span class="tLinha">Status:</span>
                
                <v-btn v-if="formLocal.status=='Agendado'"
                class="ml-2 mb-1" 
                size="x-small"
                :style="{'background':'#ec5858'}"
                @click="cancelAgend()" 
                >
                    <span>cancelar</span>
                    <v-icon>mdi-timer-edit-outline</v-icon>
                </v-btn>

                <v-chip class="ml-2" color="#397E9E">{{ formLocal.status }}</v-chip>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Dispositivo:</span>
                <div class="ml-2 elSelect" v-if="flagNovoAgend">
                    <v-autocomplete
                    v-model="deviceSelected"
                    :items="liDevicesExib"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarDevice"
                    ></v-autocomplete>
                </div>
                <v-chip v-else class="ml-2" color="#397E9E">{{ deviceSelected }}</v-chip>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Título Atuador:</span>
                <div class="ml-2 elSelect" v-if="flagNovoAgend">
                    <v-autocomplete
                    v-model="atuadorSelected"
                    :items="liSelectAtuador"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarAtuador"
                    ></v-autocomplete>
                </div>
                <v-chip v-else class="ml-2" color="#397E9E">{{ formLocal.titulo_atuador }}</v-chip>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Tipo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="tipoSelected"
                    :items="liSelectTipo"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarTipo"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm" v-if="tipoSelected == 'temporizado'">
                <span class="tLinha">Tempo:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.timeout_tempo_hr"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        :placeholder="formLocal.timeout_tempo_hr"
                        @change="atualizarFormulario('timeout')"
                    />
                </div>
            </div>

            <div class="linhaForm" v-else>
                <span class="tLinha">Atuação:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="comandoFront"
                    :items="liSelectComando"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarComando"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Porta:</span>
                <v-chip class="ml-2" color="#397E9E">{{ formLocal.pino_atuador }}</v-chip>
            </div>
        </div>

        <v-btn @click="verificar()" v-if="!handleLoading"
        color="primary"
        variant="tonal"
        :disabled="!isChanged || flagBtnChange"
        :style="{'background':'#397E9E','min-height':'60px'}">
            <span class="mt-1 mb-1" 
            style="white-space: normal; line-height: 1.2; text-align:center; color:white">
                Validar
            </span>
        </v-btn>

        <v-btn @click="upAgend()" v-if="!handleLoading"
        color="success"
        :disabled="!flagBtnChange"
        :style="{'min-height':'60px'}">
            <span class="mt-1 mb-1" 
            style="white-space: normal; line-height: 1.2; text-align:center;">
                Atualizar agendamentos
            </span>
        </v-btn>

        <div v-if="!handleLoading && flagMsgForm"
        :style="{'min-height':'60px','padding':'6px','font-size':'0.9rem','color':colorMsg}">
            <span>{{ msgForm }}</span>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import { convHhmmToUtcIso_v2 } from "../auxSC/handleTimeConv.js"; // 17/06/2026

export default {

    props:['elForm','dateToday','emailCliente','sysSelected'],

    data() {
        return {
            titForm:'EDIÇÃO',
            formLocal: {},
            elFormRef:{},
            isChanged: false,
            handleLoading:false,
            flagBtnChange:false,
            msgForm:'',
            flagMsgForm:false,
            colorMsg:'',
            hrUtcBeforeEdit:'22:01',

            flagNovoAgend:false,
            liSelectAtuador:[],
            atuadorSelected:'',
            deviceSelected:'',
            device_id_current:'',
            atuante_tag:'',
            
            liSelectTipo:['direto','temporizado'],
            liSelectComando:['ligar','desligar'],
            tipoSelected:'',
            comandoFront:'',
            liDevices:[],
            liDevicesExib:[],
            liGeralDispositivo:[],
            sistema:'',
        }
    },

    watch: {
        formLocal: {
            deep: true,
            handler(newVal) {
                const a = JSON.stringify(this.normalizeForm(newVal))
                const b = JSON.stringify(this.normalizeForm(this.elFormRef))
                const changed = (a !== b)
                this.isChanged = changed
                if (changed) this.flagBtnChange = false
            }
        }
    },

    methods: {

        deepClone(obj) {
            if (typeof structuredClone === 'function') return structuredClone(obj)
            return JSON.parse(JSON.stringify(obj))
        },

        validarHHMM(hhmm) {
            return /^([01]\d|2[0-3]):[0-5]\d$/.test((hhmm || '').trim())
        },

        validarHHMMSS(hhmmss) {
            return /^\d{2}:\d{2}:\d{2}$/.test((hhmmss || '').trim())
        },

        /*localHhmmToUtcTrigger(hhmmLocal) {

            //Monta datetime UTC completo a partir do horário local selecionado.
            //Usa o timezone do navegador. Para o caso atual, o front está sendo usado
            //no mesmo fuso operacional do cliente.

            const [hh, mm] = hhmmLocal.split(':').map(Number)
            const dtLocal = new Date()
            dtLocal.setHours(hh, mm, 0, 0)
            return dtLocal.toISOString()
        },*/

        isAtLeastMinutesAhead(hhmmLocal, minAhead = 10) {
            if (!this.validarHHMM(hhmmLocal)) return false

            const [hh, mm] = hhmmLocal.split(':').map(Number)
            const alvo = new Date()
            alvo.setHours(hh, mm, 0, 0)

            const limite = new Date(Date.now() + minAhead * 60 * 1000)

            return alvo >= limite
        },

        async upAgend() { 
            this.handleLoading = true
            this.msgForm = ''

            try {
                let tempoSegundos = null

                if (this.tipoSelected == 'temporizado') { 
                    tempoSegundos = this.HHMMSStoSegundos(this.formLocal.timeout_tempo_hr)
                    this.formLocal.op = 'Timeout'
                } else {
                    tempoSegundos = null
                    this.formLocal.op = 'Direto'
                }

                this.sistema = this.$store.state.sistemaSC
                const cl = this.$store.state.emailCliente

                this.formLocal.atuante = this.atuante_tag || this.formLocal.atuante || 'outro'
                this.formLocal.tipo = 'direto'

                //const utcTrigger = this.localHhmmToUtcTrigger(this.formLocal.hr_utc)
                const tzName = this.$store.state.fusoHorarioSC // esperado --> "Europe/Lisbon"
                const utcTrigger = convHhmmToUtcIso_v2(
                    this.formLocal.hr_utc, // "17:02"
                    this.dateToday, // "17/06/2026" (rcv via props)
                    tzName
                ) // dt string

                const el_disparo_act = {
                    utc_trigger: utcTrigger, // dt string
                    device: this.device_id_current,
                    tipo: 'direto',
                    atuante: this.formLocal.atuante,
                    titulo_atuador: this.formLocal.titulo_atuador,
                    pino_atuador: this.formLocal.pino_atuador,
                    command_hex: this.formLocal.command_hex,
                    nota: 'client-agend',
                    tempo_segundos: tempoSegundos,
                    flag_decisor: false
                }

                const params = {
                    api_client: cl,
                    sistema: this.sistema,
                    sistema_crtl: this.sistema, // <-- back nao utiliza (o sys_ctrl pode nao ser o mesmo que o sys_agend)
                    payload: el_disparo_act
                }

                //console.log('params: ',params)
                //let flagEnd = true
                //if (flagEnd) {return}

                const headers = {
                    'Authorization': `Bearer ${this.$store.state.tox}`,
                    'Content-Type': 'application/json'
                }

                setTimeout(() => { window.scrollTo(0,0) }, 400)

                const url = this.$store.state.pathAxiosBASE + '/xinputxagendxapi'
                const res = await axios.post(url, params, {headers})

                console.log('[upAgend][res]', res.data)

                const result = res?.data?.result ?? res?.data

                if (
                    result === 'Ok' ||
                    result?.ok === true ||
                    result?.flag_res === true ||
                    res.status === 200
                ) {
                    this.colorMsg = 'green'
                    this.msgForm = 'Atualizado.'
                    this.flagMsgForm = true
                    this.handleLoading = false
                    this.$emit('fromUp', this.msgForm)
                    return
                }

                this.colorMsg = 'red'
                this.msgForm = 'Não foi possível agendar. Tente novamente mais tarde.'
                this.flagMsgForm = true
                this.handleLoading = false
                this.$emit('fromUp', this.msgForm)

            } catch (e) {
                console.log('[upAgend] erro:', e)
                this.colorMsg = 'red'
                this.msgForm = 'Falha ao tentar atualizar o sistema. Tente novamente mais tarde.'
                this.flagMsgForm = true
                this.handleLoading = false
            }
        },

        verificar() {
            this.handleLoading = true

            let minutos_untill_trigger = 10
            if (this.$store.state.sistemaSC == 'upinc3') { minutos_untill_trigger = 4 } // mqtt
            
            if (!this.isAtLeastMinutesAhead(this.formLocal.hr_utc, minutos_untill_trigger)) {
                this.flagMsgForm = true
                this.msgForm = `O horário selecionado deve respeitar um intervalo mínimo de ${minutos_untill_trigger} minutos em relação ao momento atual.`
                this.colorMsg = '#ec5858'
                this.handleLoading = false
                return
            }

            let segundos = null

            if (this.tipoSelected == 'temporizado') { 
                if (!this.validarHHMMSS(this.formLocal.timeout_tempo_hr)) {
                    this.flagMsgForm = true
                    this.msgForm = 'Formato 00:00:00 obrigatório para o temporizador.'
                    this.colorMsg = '#ec5858'
                    this.handleLoading = false
                    return
                }

                segundos = this.HHMMSStoSegundos(this.formLocal.timeout_tempo_hr)

                if (segundos > 241) { 
                    this.flagMsgForm = true
                    this.msgForm = 'Tempo máximo 4 minutos para esta versão. Utilize o disparo direto para períodos maiores.'
                    this.colorMsg = '#ec5858'
                    this.handleLoading = false
                    return
                }
            }

            const required = [
                'hr_utc',
                'titulo_atuador',
                'pino_atuador',
                'command_hex'
            ]

            const missing = required.filter(k => {
                const v = this.formLocal?.[k]
                if (v === null || v === undefined) return true
                if (typeof v === 'string' && v.trim() === '') return true
                if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return true
                return false
            })

            if (!this.device_id_current || this.device_id_current.trim() === '') {
                missing.push('device')
            }

            if (!this.tipoSelected || this.tipoSelected.trim() === '') {
                missing.push('tipo')
            }

            if (missing.length > 0) {
                this.flagMsgForm = true
                this.msgForm = 'Todos os campos devem ser preenchidos.'
                this.colorMsg = '#ec5858'
                this.handleLoading = false
                return
            }

            this.colorMsg = ''
            this.msgForm = 'Verificação preliminar concluída. O horário e as configurações selecionadas estão disponíveis.'
            this.flagMsgForm = true
            this.flagBtnChange = true
            this.resetBaselineFromCurrent()
            this.handleLoading = false
        },

        cancelAgend() {
            this.handleLoading = true
            this.msgForm = ''

            this.sistema = this.$store.state.sistemaSC
            const cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            const params = {
                cliente: cl,
                sistema: this.sistema,
                step2remove: this.formLocal.step
            }

            setTimeout(() => {
                window.scrollTo(0,0)
            },400)

            const url = this.$store.state.pathAxiosBASE + '/cancelxagend'

            axios.post(url, params, {headers}).then((res) => {
                console.log(res.data.result)
                
                if (res.data.result == 'cancel-end') {
                    this.colorMsg = ''
                    this.msgForm = 'Cancelado.'
                    this.flagMsgForm = true
                    this.handleLoading = false
                    this.$emit('fromUp', this.msgForm)
                } else {
                    this.colorMsg = 'red'
                    this.msgForm = 'Não foi possível cancelar. Tente novamente mais tarde.'
                    this.flagMsgForm = true
                    this.handleLoading = false
                    this.$emit('fromUp', this.msgForm)
                }
            }).catch((e) => {
                console.log('[cancelAgend] erro:', e)
                this.colorMsg = 'red'
                this.msgForm = 'Não foi possível cancelar. Tente novamente mais tarde.'
                this.flagMsgForm = true
                this.handleLoading = false
            })
        },

        HHMMSStoSegundos(hhmmss) {
            const [h, m, s] = hhmmss.split(":").map(Number)
            return (h * 3600) + (m * 60) + s
        },

        segundosParaHHMMSS(totalSegundos) {
            const horas = Math.floor(totalSegundos / 3600)
            const minutos = Math.floor((totalSegundos % 3600) / 60)
            const segundos = totalSegundos % 60
            const pad = (num) => String(num).padStart(2, '0')
            return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`
        },

        atualizarFormulario(flagStr) { 
            if (flagStr == 'timeout') {
                const s = (this.formLocal.timeout_tempo_hr || '').trim()

                if (!this.validarHHMMSS(s)) {
                    this.formLocal.timeout_tempo_hr = "00:00:01"
                    this.msgForm = 'Formato 00:00:00 obrigatório para o temporizador.'
                    this.colorMsg = '#ec5858'
                    this.flagMsgForm = true
                } else {
                    this.msgForm = ''
                    this.colorMsg = ''
                    this.flagMsgForm = false
                }
            }

            if (flagStr == 'hhmm') {
                const s = (this.formLocal.hr_utc || '').trim()

                if (!this.validarHHMM(s)) {
                    this.formLocal.hr_utc = this.hrUtcBeforeEdit ?? this.formLocal.hr_utc
                    this.msgForm = 'Formato 00:01 obrigatório para as horas de 00:01 até 23:59.'
                    this.colorMsg = '#ec5858'
                    this.flagMsgForm = true
                } else {
                    this.formLocal.hr_utc = s
                    this.hrUtcBeforeEdit = s
                    this.msgForm = ''
                    this.colorMsg = ''
                    this.flagMsgForm = false
                }
            }
        },

        trocarDevice(deviceSelected) { 
            this.device_id_current = ''
            this.liSelectAtuador = []
            this.atuadorSelected = ''
            this.formLocal.titulo_atuador = ''
            this.formLocal.pino_atuador = ''
            this.formLocal.command_hex = ''

            let c = 0
            while (c < this.liDevices.length) {
                if (this.liDevices[c]['nome_device'] == deviceSelected) {
                    this.device_id_current = this.liDevices[c]['device']
                    this.liGeralDispositivo = this.liDevices[c]['liAtuadores']

                    let j = 0
                    while (j < this.liGeralDispositivo.length) {
                        this.liSelectAtuador.push(this.liGeralDispositivo[j]['tit'])
                        j++
                    }

                    return
                }
                c++
            }
        },

        trocarAtuador(atuadorSelected) {
            this.formLocal.titulo_atuador = atuadorSelected

            let c = 0
            while (c < this.liGeralDispositivo.length) {
                if (this.liGeralDispositivo[c]['tit'] == atuadorSelected) {
                    this.formLocal.pino_atuador = this.liGeralDispositivo[c]['porta']
                    this.atuante_tag = this.liGeralDispositivo[c]['atuante']

                    if (!this.tipoSelected || this.tipoSelected.trim() === '') {
                        this.trocarTipo('direto')
                        return
                    }

                    this.trocarTipo(this.tipoSelected)
                    return
                }
                c++
            }
        },

        trocarTipo(tipoSelected) {
            if (tipoSelected == 'temporizado') {
                this.tipoSelected = tipoSelected

                if (!this.formLocal.timeout_tempo_hr) {
                    this.formLocal.timeout_tempo_hr = this.segundosParaHHMMSS(1)
                } else {
                    this.formLocal.timeout_tempo_hr = "00:00:01"
                }

                this.formLocal.command_hex = '06' + this.formLocal.pino_atuador
                this.formLocal.op = 'Timeout'
            }
            
            if (tipoSelected == 'direto') {
                this.tipoSelected = tipoSelected

                if (!this.comandoFront || this.comandoFront.trim() === '') {
                    this.comandoFront = 'desligar'
                }

                this.trocarComando(this.comandoFront)
                this.formLocal.op = 'Direto'
            }
        },

        trocarComando(comandoFront) {
            if (!this.formLocal.pino_atuador) return

            if (comandoFront == 'desligar') {
                this.formLocal.command_hex = '09' + this.formLocal.pino_atuador
            }

            if (comandoFront == 'ligar') {
                this.formLocal.command_hex = '08' + this.formLocal.pino_atuador
            }
        },

        normalizeForm(obj) {
            const out = this.deepClone(obj || {})

            if (out?.timeout_tempo_hr != null) {
                if (typeof out.timeout_tempo_hr === 'number') {
                    out.timeout_tempo_hr = this.segundosParaHHMMSS(out.timeout_tempo_hr)
                }
            }

            return out
        },

        cloneFromProps() {
            const snap = this.deepClone(this.elForm || {})
            this.formLocal = snap
            this.elFormRef = this.deepClone(snap)
            this.hrUtcBeforeEdit = this.formLocal.hr_utc
        },

        resetBaselineFromCurrent() {
            this.elFormRef = this.deepClone(this.formLocal)
        },

        init() {
            if (this.elForm.step < 0) { 
                this.titForm = 'NOVO AGENDAMENTO'
                this.sistema = this.$store.state.sistemaSC
                const cl = this.$store.state.emailCliente

                const headers = {
                    'Authorization': `Bearer ${this.$store.state.tox}`,
                    'Content-Type': 'application/json'
                }

                const params = {
                    cliente: cl,
                    sistema: this.sistema
                }

                axios.post(this.$store.state.pathAxiosAgentIA, params, {headers}).then((res) => {
                    const el = res.data.result
                    const liAtuadores = el['atuadores'] || []

                    let c = 0
                    while (c < liAtuadores.length) {
                        const paramsAtuadores = liAtuadores[c]['params'] || []
                        const liAtu = []

                        let j = 0
                        while (j < paramsAtuadores.length) {
                            if (paramsAtuadores[j]['status'] == 'on') { 
                                liAtu.push({
                                    tit: paramsAtuadores[j]['titulo'],
                                    atuante: paramsAtuadores[j]['sub_marcador'],
                                    porta: paramsAtuadores[j]['pino']
                                })
                            }
                            j++
                        }

                        this.liDevices.push({
                            nome_device: liAtuadores[c]['nome'], 
                            device: liAtuadores[c]['device'], 
                            liAtuadores: liAtu
                        })

                        this.liDevicesExib.push(liAtuadores[c]['nome'])
                        c++
                    }
                }).catch((e) => {
                    console.log('[FormAgend][init] erro ao buscar agent:', e)
                    this.flagMsgForm = true
                    this.colorMsg = '#ec5858'
                    this.msgForm = 'Não foi possível carregar os atuadores.'
                })

                this.flagNovoAgend = true
            } else { 
                this.titForm = 'EDIÇÃO'
            
                if (this.elForm.op == 'Timeout') {
                    this.tipoSelected = 'temporizado'
                } else {
                    this.tipoSelected = 'direto'
                }

                if (this.elForm.id_job) {
                    const liIdJob = this.elForm.id_job.split("_")
                    this.deviceSelected = liIdJob[2] || ''
                    this.device_id_current = this.deviceSelected

                    console.log('liIdJob[5]: ',liIdJob[5])
                    const comando = liIdJob[5] || '' // <--- quando habilitar (atenção ao id_job!)
                    const canal_comando = comando.slice(0, 2)

                    if (canal_comando == '09') this.comandoFront = 'desligar'
                    if (canal_comando == '08') this.comandoFront = 'ligar'
                }

                this.atuante_tag = this.elForm.atuante || ''
            }

            this.cloneFromProps()
        },
    },

    created() {
        this.init()
    }
}
</script>